/**
 * Created by AlexanderC on 6/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnknownMethodException = undefined;

var _Exception2 = require('../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when requested method is missing from allowed vector
 */
let UnknownMethodException = exports.UnknownMethodException = function (_Exception) {
  _inherits(UnknownMethodException, _Exception);

  /**
   * @param {String} requestedMethod
   * @param {Array} availableMethods
   */
  function UnknownMethodException(requestedMethod, availableMethods) {
    _classCallCheck(this, UnknownMethodException);

    let availableList = availableMethods.join(', ');

    return _possibleConstructorReturn(this, (UnknownMethodException.__proto__ || Object.getPrototypeOf(UnknownMethodException)).call(this, `Requested method ${requestedMethod} must be one of ${availableList}`));
  }

  return UnknownMethodException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Exception/UnknownMethodException.js
// module id = 425
// module chunks = 0